import React from "react";
import ImageCrop from "./ImageCrop";

/**
 * Modal wrapper for image cropping functionality.
 * - `imageSrc`: The image to crop, can be a URL, file object, or null.
 * - `isOpen`: Controls the modal visibility (boolean).
 * - `onClose`: Callback to close the modal and optionally clear the image.
 * - `onCropComplete`: Callback to return the cropped image.
 * - `aspectRatios`: List of allowed aspect ratios for cropping pass as props from the sender.
 * - `allowedOrientations`: Allowed crop orientations (e.g., landscape, portrait is only applicable ( Circle is just a display)).
 *
 * @param {string | File | null} imageSrc - Image source for cropping.
 * @param {boolean} isOpen - Modal open state.
 * @param {function} onClose - Callback to close the modal.
 * @param {function} onCropComplete - Callback to return cropped image.
 * @param {Array} aspectRatios - Allowed aspect ratios for cropping.
 * @param {Array} allowedOrientations - List of allowed crop orientations (e.g., landscape, portrait).
 */

export default function ImageCropModal({
    imageSrc,
    isOpen,
    onClose,
    onCropComplete,
    aspectRatios,
    allowedOrientations,
    returnAspectRationResult = false,
    lockedAspectRatio
}) {
    const handleCropComplete = (croppedImage, width, height, aspectRatioLabel) => {
        onCropComplete(croppedImage, width, height, aspectRatioLabel);
        onClose(false);
    };

    return (
        <ImageCrop
            imageSrc={imageSrc}
            isOpen={isOpen}
            onClose={(shouldClear = true) => onClose(shouldClear)}
            onCropComplete={handleCropComplete}
            aspectRatios={aspectRatios}
            allowedOrientations={allowedOrientations}
            returnAspectRationResult={returnAspectRationResult}
            lockedAspectRatio={lockedAspectRatio}
        />
    );
}
